<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">太平洋发薪</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInDetail">
      <section class="searchBox">
        <span>
          <label>日期：</label>
          <a-date-picker v-model="date" @change="onChangeDate" />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            v-model="query_field"
            style="width:200px"
            placeholder="请输入批次编号|姓名|手机号|openid|身份证号"
          />
        </span>
        <span>
          <label>状态：</label>
          <!-- 回调发送状态：1待发 2已发 3 回调失败  20 回调成功 -->
          <a-select
            style="width: 140px"
            v-model="send_status"
            :allowClear="true"
          >
            <a-select-option :value="1">待发</a-select-option>
            <a-select-option :value="2">已发</a-select-option>
            <a-select-option :value="3">回调失败</a-select-option>
            <a-select-option :value="20">回调成功</a-select-option>
          </a-select>
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset" style="margin-right:10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
        <span>
          <a-button type="primary" @click="onekeySubmit">一键确认</a-button>
          <a-button type="primary" @click="selectSubmit">批量确认</a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <a-table
          :data-source="tableList"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            getCheckboxProps: getCheckboxProps
          }"
          :scroll="{ x: 1500 }"
          :pagination="false"
          :columns="columns"
          :rowKey="reord => reord.id"
        >
          <span slot="send_status" slot-scope="item">
            <span>
              {{
                item.send_status == 1
                  ? "待发"
                  : item.send_status == 2
                  ? "已发"
                  : "失败"
              }}
            </span>
          </span>
          <span slot="action" slot-scope="item">
            <span class="btn ant-dropdown-link" @click="detailPage(item)">
              <a>详情</a>
            </span>
          </span>
        </a-table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <cpicPaymentDetail
      v-show="hideInDetail"
      :detailVal="detailVal"
      v-on:hideInDetailPage="hideInDetailPage"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import cpicPaymentDetail from "@/components/money/cpicPaymentDetail"; //详情

const columns = [
  {
    title: "姓名",
    dataIndex: "identity_name",
    align: "center",
    fixed: "left",
    width: 120
  },
  {
    title: "ID",
    dataIndex: "id",
    align: "center",
    width: 50
  },
  {
    title: "表格日期",
    dataIndex: "salary_date",
    align: "center",
    width: 150
  },
  {
    title: "手机号",
    dataIndex: "phone",
    align: "center",
    width: 150
  },
  {
    title: "身份证号",
    dataIndex: "idcard",
    align: "right",
    width: 200
  },
  {
    title: "银行卡号",
    dataIndex: "bank_card_number",
    align: "right",
    width: 200
  },
  {
    title: "结算单号",
    dataIndex: "batch_no",
    width: 200
  },
  {
    title: "订单号",
    dataIndex: "order_id",
    width: 200
  },
  {
    title: "结算金额",
    dataIndex: "pre_amount",
    align: "right",
    width: 150
  },
  {
    title: "实发金额",
    dataIndex: "real_amount",
    align: "right",
    width: 150
  },
  {
    title: "状态",
    slots: { title: "send_status" },
    scopedSlots: { customRender: "send_status" },
    width: 100
  },
  {
    title: "操作", //"详情",
    slots: { title: "actionTitle" },
    scopedSlots: { customRender: "action" },
    width: 100
  }
];
export default {
  components: {
    cpicPaymentDetail
  },
  data() {
    return {
      columns,
      data: [],
      tableList: [],
      selectedRowKeys: [],
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      hideInDetail: false,
      start_date: "",
      end_date: "",
      date: null,
      detailVal: "",
      ids: [],
      send_status: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    getCheckboxProps(record) {
      return {
        props: {
          // name: record.send_status,
          //当状态是1或者2的时候执行disable
          disabled: record.send_status === 2 || record.send_status === 20
        }
      };
    },
    onekeySubmit() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "Tpy_user/sendSalaryAll";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.sussess(res.data.message);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    selectSubmit() {
      if (this.ids.length > 0) {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.user +
          "Tpy_user/sendSalaryBatch";
        axios
          .post(url, {
            ids: JSON.stringify(this.ids),
            token: window.localStorage.getItem("xnwfPcToken")
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.sussess(res.data.message);
              this.ids = [];
              this.selectedRowKeys = [];
            } else {
              this.$message.warning(res.data.message);
              this.selectedRowKeys = [];
            }
          })
          .catch(err => {
            this.$message.error("服务器出错啦...");
            this.loading = false;
          });
      } else {
        this.$message.warning("请选择需要确认的数据");
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.ids = selectedRowKeys;
    },
    hideInDetailPage(msg) {
      this.hideInDetail = false;
      if (msg) {
        this.reload();
      }
    },
    detailPage(item) {
      this.hideInDetail = true;
      this.detailVal = item;
    },
    onChangeDate(date, dateString) {
      // console.log(dateString)
      this.start_date = dateString;
      this.end_date = dateString;
    },
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Tpy_user/downloadSalaryList?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date;
    },
    onReset() {
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.date = null;
      this.page = 1;
      this.selectedRowKeys = [];
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.selectedRowKeys = [];
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = false;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInDetail = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      this.tableList = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "Tpy_user/uploadSalaryList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          start_date: this.start_date,
          end_date: this.end_date,
          send_status: this.send_status,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.tableList = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);

.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;

    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;

      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
